import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  constructor() { }

  slides = [
    {img: 'assets/one_stop.png', title: 'One Stop Shop', text: 'With expert advice, Neprose is here to make your experience a convenient one.'},
    {img: 'assets/easy_payment.png', title: 'Easy Payment', text: 'Get started with your ads quickly by paying through bank or Esewa.'},
    {img: 'assets/discover.png', title: 'Discover', text: 'Your next real estate investment opportunity could be right around the corner.'},
    {img: 'assets/payment_plans.png', title: 'Ad Plans', text: 'Our Advertisement plans are varied and suitable for a host of different needs.'},
    {img: 'assets/blog.png', title: 'Get Insights', text: 'Get insights into buying and selling by reading our blogs/opinion pieces.'}
  ]

  pages = [
    {value: 1, viewValue: 'Home Page'},
    {value: 2, viewValue: 'About Page'},
    {value: 3, viewValue: 'Contact Page'},
    {value: 4, viewValue: 'Blog Page'}
  ]

  slideConfig = {
    "slidesToShow": 4, 
    "slidesToScroll": 1, 
    responsive: [
      {
        "breakpoint": 1024,
        "settings": {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        "breakpoint": 768,
        "settings": {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  ngOnInit(): void {
  }

}
